<div class="w-100 d-flex justify-content-between pb-2 bg-white" style="position: sticky;
                bottom: 0">
  <button class="btn btn-primary" (click)="selectAll()">{{'ADDDATA.URL.selectAll' |
    translateHs }}</button>
  <hs-add-to-map [disabled]="!hsAddDataUrlService.addingAllowed" (add)="add()"
    [title]="'ADDLAYERS.addSelected'"></hs-add-to-map>
</div>
